import { render, staticRenderFns } from "./SetReminderActions.vue?vue&type=template&id=5d769186&scoped=true&"
import script from "./SetReminderActions.vue?vue&type=script&lang=ts&"
export * from "./SetReminderActions.vue?vue&type=script&lang=ts&"
import style0 from "./SetReminderActions.vue?vue&type=style&index=0&id=5d769186&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d769186",
  null
  
)

export default component.exports